import {createModel} from "@rematch/core";
import {RootModel} from "./index";
import request from "../util/request";

export const examiner = createModel<RootModel>()({
  state: {
    info: {},
    request: {
      keyword: "",
      pageNum: 1,
      pageSize: 20,
    },
    data: {
      total: 0,
      pageNum: 1,
      pageSize: 20,
      list: [],
    },
  }, // initial state
  reducers: {
    // handle state changes with pure functions
    /**
     * 设置值
     *
     * @param state
     * @param payload
     */
    setData(state, payload) {
      return {...state, ...payload}
    }
  },
  effects: (dispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    /**
     * 分页显示
     */
    async page(payload, state): Promise<any> {
      let res = await request.post("/host-admin/v1/examiner/page", state.examiner.request)
      if (res.code === 0) {
        res.data.list.forEach((item: any) => {
          item.key = item.id
        })
        dispatch.examiner.setData({data: res.data})
      }
      return res
    },

    /**
     * 添加
     *
     * @param payload
     * @param state
     */
    async add(payload, state): Promise<any> {
      let res = await request.post("/host-admin/v1/examiner", payload)
      return res
    },

    /**
     * 修改
     *
     * @param payload
     * @param state
     */
    async modify(payload, state): Promise<any> {
      let res = await request.put("/host-admin/v1/examiner", payload)
      return res
    },

  }),
})